<template>
  <div class="chart-pie" ref="chartdiv" :style="{ height: (chartSettings.height + 'px') || '400px' }"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

export default {
  name: 'chartPieRender',
  props: {
    chartKey: { type: String, required: true }
  },
  data () {
    return {
      chartSettings: {},
      chartData: []
    }
  },
  computed: {
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  mounted () {
    let self = this
    this.chartSettings = this.chartObj.chartSettings
    this.chartData = this.chartObj.data.result

    // Create chart instance
    let chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart)
    chart.paddingRight = 25

    // Add data
    chart.data = this.chartData

    // Enable export if 'true' in chart setting
    /* if (this.chartObj.export) {
      chart.events.on('ready', () => {
        chart.exporting.menu = new am4core.ExportMenu()
        chart.exporting.menu.align = 'right'
        chart.exporting.menu.verticalAlign = 'bottom'
        chart.exporting.menu.items = [{
          'label': '...',
          'menu': [
            {
              'label': 'Image',
              'menu': [
                { 'type': 'png', 'label': 'PNG' },
                { 'type': 'jpg', 'label': 'JPG' },
                { 'type': 'gif', 'label': 'GIF' },
                { 'type': 'svg', 'label': 'SVG' },
                { 'type': 'pdf', 'label': 'PDF' }
              ]
            }, {
              'label': 'Data',
              'menu': [
                // { 'type': 'json', 'label': 'JSON' },
                { 'type': 'csv', 'label': 'CSV' }
                // { 'type': 'xlsx', 'label': 'XLSX' }
              ]
            }, {
              'label': 'Print', 'type': 'print'
            }
          ]
        }]
      })
    } */

    // Add and configure Series
    let pieSeries = chart.series.push(new am4charts.PieSeries())
    pieSeries.dataFields.category = this.$_.keys(this.chartData[0])[0]
    pieSeries.dataFields.value = this.$_.keys(this.chartData[0])[1]
    pieSeries.labels.template.text = "[bold]{name}[/]: {value.percent.formatNumber('#.0')}%"
    pieSeries.ticks.template.disabled = false

    let categoryLabel = pieSeries.labels.template
    categoryLabel.fontSize = 11
    categoryLabel.wrap = true
    categoryLabel.maxWidth = 240

    chart.legend = new am4charts.Legend()
    self.chartSettings.legendAlwaysShow !== undefined
      ? chart.legend.disabled = !self.chartSettings.legendAlwaysShow
      : chart.legend.disabled = true
    chart.legend.paddingLeft = 20
    chart.legend.paddingRight = 20
    chart.legend.paddingBottom = 0
    chart.legend.position = this.chartObj.chartSettings.legendPosition ? this.chartObj.chartSettings.legendPosition : 'bottom'
    // chart.legend.itemContainers.template.clickable = false
    // chart.legend.itemContainers.template.focusable = false
    // chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default

    chart.responsive.enabled = true
    chart.responsive.useDefault = false
    chart.responsive.rules.push({
      relevant: target => target.pixelWidth < (self.chartSettings.switchToLegendBelow || 650),
      state: function (target, stateId) {
        if (target instanceof am4charts.Legend) {
          let state = target.states.create(stateId)
          state.properties.disabled = false
          state.properties.paddingBottom = 50
          return state
        }
        if (target instanceof am4charts.PieSeries) {
          let state = target.labels.template.states.create(stateId)
          state.properties.text = ''
          let stateTicks = target.ticks.template.states.create(stateId)
          stateTicks.properties.disabled = true
          return state
        }
        return null
      }
    })

    /* - pie chart with too many values - */
    // modify pie labels
    if (self.chartSettings.noPieLabelsPadding) {
      pieSeries.labels.template.padding(0, 0, 0, 0)
    }
    if (self.chartSettings.hidePercentValuesBelow) {
      pieSeries.ticks.template.adapter.add('hidden', hideSmall)
      pieSeries.labels.template.adapter.add('hidden', hideSmall)
    }
    function hideSmall (hidden, target) {
      return target.dataItem.values.value.percent < self.chartSettings.hidePercentValuesBelow
    }
    // modify legend labels
    chart.legend.itemContainers.template.paddingTop = self.chartSettings.legendItemsPaddingTop || 5
    chart.legend.itemContainers.template.paddingBottom = self.chartSettings.legendItemsPaddingBottom || 5
    chart.legend.fontSize = self.chartSettings.legendFontSize || 12
    let markerTemplate = chart.legend.markers.template
    markerTemplate.width = self.chartSettings.markerTemplateWidth || 20
    markerTemplate.height = self.chartSettings.markerTemplateHeight || 20
    /* - pie chart with too many values - END */

    this.chart = chart
  },
  methods: {},
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .chart-pie {
    width: 100%;
    height: 400px;
  }
</style>
